import dev from '@/config/dev';
import homestead from '@/config/homestead';
import canary from '@/config/canary';

const env = process.env.VUE_APP_ENV || 'homestead';
const configs: any = { dev, homestead, canary };

const config: any = configs[env];

export default config;
